<app-form-page [content]="content" [input]="input" [action]="action" />

<ng-template #content>

  @if (errorMessage) {
    <div class="m-t-2 m-b-3 text-align-center text-danger-main">
      {{ errorMessage }}
    </div>
  }




  <div class="m-t-2 m-b-3 text-align-center">
    <svg-icon
      role="img"
      src="assets/images/aptem-assess-logo-content.svg"
      data-ua-id="landing-page-logo"
      >
    </svg-icon>
  </div>

  <h2 class="text-bold text-align-center m-b-3">
    <span>Start using Aptem Assess today</span>
  </h2>

  <div class="content-layout-column m-t-3 m-b-3">
    <div>
      <p>
        Here, you can register for free access to the entire Aptem Assess product.

      </p>

      <p>
        In order to get you started we need a couple of details.
      </p>
    </div>
  </div>
</ng-template>

<form [formGroup]="landingForm" (ngSubmit)="onSubmit()">
  <ng-template #input>
    <div class="text-text-main">
      <app-text-input
        trackingId="full-name-input-landing"
        [config]="{
          label: 'Full name',
          controlName: 'fullName',
          elementId: '1',
        }"
        >
      </app-text-input>
    </div>
    <div class="text-text-main">
      <app-text-input
        trackingId="email-input-landing"
        [config]="{
          label: 'Business email',
          controlName: 'emailAddress',
          elementId: '2'
        }"
        >
      </app-text-input>
    </div>
  </ng-template>

  <ng-template #action>
    <div class="action-button-block-sm-center-md">
      <app-button
        [config]="{ type: 'submit', disabled: landingForm.invalid }"
        trackingId="signup-landing"
        (clicked)="onSubmit()"
        >
        Send invite
      </app-button>
    </div>
  </ng-template>
</form>
